import moment from "moment";
import { memo } from "react";

function NewsCard(props) {
    return (
        <div
            className="w-[280px] min-w-[280px] p-3 gap-3 bg-white rounded-xl flex flex-row border border-[#DFDFDF] shadow-[0_1px_2px_rgba(0,0,0,0.1)]"
            onClick={() => window.open(props.data.url, "_blank")}
        >
            <img alt="news" src={props.data.imageUrl} className="w-[86px] h-[76px] rounded-lg" loading="lazy" />
            <div className="h-[76px]">
                <p className="font-Inter ">
                    <span className="line-clamp-2 text-black text-sm leading-6 font-semibold">{props.data.title}</span>
                </p>
                <p className="font-Inter flex flex-row text-[#414141] text-xs font-normal mt-1">
                    {props.data.source}
                    <span className="ml-auto">{moment(props.data.publishedAt).fromNow()} </span>
                </p>
            </div>
        </div>
    );
}

export default memo(NewsCard);
